var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _path6, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c9c52ea905"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 3.535156 L 29.488281 3.535156 L 29.488281 18 L 0.484375 18 Z M 0.484375 3.535156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b6366f70b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 3.535156 L 28 3.535156 L 28 8 L 23 8 Z M 23 3.535156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13a5ee2aa3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 3.535156 L 7 3.535156 L 7 8 L 2 8 Z M 2 3.535156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e14c45c182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8 8 L 28 8 L 28 25.3125 L 8 25.3125 Z M 8 8 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9c52ea905)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 6.234375 9.738281 L 14.972656 3.535156 L 29.484375 13.84375 L 29.484375 17.03125 L 14.972656 6.742188 L 6.234375 12.945312 Z M 0.464844 13.84375 L 2.292969 12.542969 L 2.292969 15.742188 L 0.464844 17.03125 Z M 0.464844 13.84375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b6366f70b3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 27.636719 5.484375 C 27.636719 4.417969 26.765625 3.535156 25.695312 3.535156 C 24.621094 3.535156 23.730469 4.417969 23.730469 5.484375 C 23.730469 6.550781 24.621094 7.417969 25.695312 7.417969 C 26.765625 7.421875 27.636719 6.558594 27.636719 5.484375 Z M 27.636719 5.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 6.285156 13.894531 L 14.972656 9.066406 L 23.664062 13.894531 L 14.972656 7.808594 Z M 6.285156 13.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 12.636719 13.808594 L 14.734375 13.808594 L 14.734375 15.898438 L 12.636719 15.898438 Z M 12.636719 13.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 15.210938 13.808594 L 17.3125 13.808594 L 17.3125 15.898438 L 15.210938 15.898438 Z M 15.210938 13.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 12.636719 16.359375 L 14.734375 16.359375 L 14.734375 18.421875 L 12.636719 18.421875 Z M 12.636719 16.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 15.210938 16.359375 L 17.3125 16.359375 L 17.3125 18.421875 L 15.210938 18.421875 Z M 15.210938 16.359375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13a5ee2aa3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 6.214844 5.484375 C 6.214844 4.417969 5.34375 3.535156 4.253906 3.535156 C 3.179688 3.535156 2.308594 4.417969 2.308594 5.484375 C 2.308594 6.550781 3.179688 7.417969 4.253906 7.417969 C 5.34375 7.421875 6.214844 6.558594 6.214844 5.484375 Z M 6.214844 5.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9461f7",
    d: "M 14.972656 22.699219 C 12.398438 22.699219 10.039062 21.648438 8.335938 19.957031 C 6.628906 18.277344 5.570312 15.9375 5.570312 13.378906 C 5.570312 10.695312 5.570312 12.476562 5.570312 9.796875 L 5.570312 9.457031 C 5.570312 8.742188 4.992188 8.164062 4.269531 8.164062 L 4.253906 8.164062 C 3.535156 8.164062 2.941406 8.742188 2.941406 9.457031 L 2.941406 9.796875 C 2.941406 12.375 2.941406 10.476562 2.941406 13.054688 L 2.941406 13.378906 C 2.941406 16.652344 4.304688 19.648438 6.476562 21.804688 C 6.855469 22.179688 7.242188 22.519531 7.671875 22.835938 L 8.183594 22.941406 C 11.121094 23.535156 14.398438 23.65625 17.230469 22.601562 C 17.625 22.464844 18.101562 22.242188 18.5625 21.992188 C 17.445312 22.441406 16.238281 22.699219 14.972656 22.699219 Z M 14.972656 22.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e14c45c182)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M 20.128906 21.15625 C 20.128906 21.15625 16.664062 24.882812 8.140625 23.1875 C 10.070312 24.527344 12.441406 25.3125 14.96875 25.3125 C 18.28125 25.3125 21.28125 23.972656 23.472656 21.800781 C 25.640625 19.644531 27.003906 16.644531 27.003906 13.371094 L 27.003906 13.046875 C 27.003906 10.472656 27.003906 12.367188 27.003906 9.792969 L 27.003906 9.453125 C 27.003906 8.738281 26.40625 8.160156 25.707031 8.160156 L 25.671875 8.160156 C 24.949219 8.160156 24.371094 8.738281 24.371094 9.453125 L 24.371094 9.792969 C 24.371094 12.472656 24.371094 10.691406 24.371094 13.371094 C 24.371094 15.929688 23.3125 18.273438 21.609375 19.949219 C 21.15625 20.40625 20.65625 20.8125 20.128906 21.15625 Z M 20.128906 21.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f1c526093f44d5af30d8b3b7d764c263.svg";
export { ForwardRef as ReactComponent };